module.exports = __webpack_public_path__ + "img/act_icon_07.58e85d8.png";